import { shallowRef } from 'vue'
import { documentAgreementParticipants } from '@/requests/documentAgreement'
import { DocumentAgreementParticipant } from '@/utils/types/documentAgreement'
import { openDialog } from '@/dialog'
import { DocumentAgreementContext } from '../types'

export function useParticipants(context: DocumentAgreementContext) {
  const { documentAgreementId, documentAgreementSource } = context
  const participants = shallowRef<DocumentAgreementParticipant[]>([])

  const getParticipants = () => {
    return documentAgreementParticipants(documentAgreementId.value).then(
      res => {
        participants.value = res
      }
    )
  }

  const openParticipantsDialog = () => {
    openDialog({
      name: 'DocumentAgreementUsers',
      dialogData: {
        participants: participants.value,
        name: documentAgreementSource.name,
      },
      params: { hideActionButtons: true },
    })
  }

  return { participants, getParticipants, openParticipantsDialog }
}
